import { TAPICountry } from './countries.hook';

export const mockedCountriesResponse: TAPICountry[] = [
  {
    "key": "AD",
    "country": "Andorra"
  },
  {
    "key": "AE",
    "country": "United Arab Emirates"
  },
  {
    "key": "AF",
    "country": "Afghanistan"
  },
];
